import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';



export const addressListService = params => axios.get(API.ADDRESS_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


export const addressCreateService = params => axios.post(API.CREATE_ADDRESS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const addressDeleteService = params => axios.post(API.DELETE_ADDRESS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const addressUpdateService = params => axios.post(API.UPDATE_ADDRESS, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

//currency

export const currencyListService = params => axios.get(API.CURRENCY_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});
export const currencyCreateService = params => axios.post(API.CREATE_CURRENCY, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const currencyDeleteService = params => axios.post(API.DELETE_CURRENCY, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});

export const currencyUpdateService = params => axios.post(API.UPDATE_CURRENCY, params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


